import styled from 'styled-components/macro';

export const TabsContainer = styled.div`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  padding-top: 17px;
  margin-bottom: 20px;
  min-height: 300px;
  flex: 1;
`;

export const Title = styled.div`
  margin: 0 0 15px 0;
`;

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 18px 0 10px 0;
`;

export const ControlsSearch = styled.div`
  width: 257px;
`;

export const ControlsButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > * {
    margin-left: 8px;
  }
`;

export const ContentContainer = styled.div`
  padding-bottom: 100px;
`;
